import { JSONSchemaType } from 'ajv'

export interface IProfileOptionFormData {
  id: string
  profileId: string
  menuOptionKey: string
  permitAll: boolean
  permitCreate: boolean
  permitRestore: boolean
  permitUpdate: boolean
  permitDelete: boolean
  disabled: boolean
}

const ProfileOptionSchema: JSONSchemaType<IProfileOptionFormData> = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    profileId: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório.',
    },
    menuOptionKey: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório.',
    },
    permitAll: {
      type: 'boolean',
      default: false,
    },
    permitCreate: {
      type: 'boolean',
      default: false,
    },
    permitRestore: {
      type: 'boolean',
      default: false,
    },
    permitUpdate: {
      type: 'boolean',
      default: false,
    },
    permitDelete: {
      type: 'boolean',
      default: false,
    },
    disabled: {
      type: 'boolean',
      default: false,
    },
  },
  required: ['profileId', 'menuOptionKey'],
  additionalProperties: false,
}

export default ProfileOptionSchema
